export default "__VITE_ASSET__b66c881b__"